import React, { useContext } from 'react'
import { Link } from 'react-router-dom'

// import NavLeft from "./NavLeft";
import NavRight from './NavRight'

import { ConfigContext } from '../../../contexts/ConfigContext'
import * as actionType from '../../../store/actions'
import { getLocalStorage } from '../../../utils/localStorage'

function NavBar({
  entity,
  scope,
  entity_scope_name,
  username,
  profile,
  logo,
  admin,
  client_access,
}) {
  // const [moreToggle, setMoreToggle] = useState(false);
  const configContext = useContext(ConfigContext)
  const {
    collapseMenu,
    headerBackColor,
    headerFixedLayout,
    layout,
    subLayout,
  } = configContext.state
  const { dispatch } = configContext

  let headerClass = [
    'navbar',
    'pcoded-header',
    'navbar-expand-lg',
    headerBackColor,
  ]
  if (headerFixedLayout && layout === 'vertical') {
    headerClass = [...headerClass, 'headerpos-fixed']
  }

  let toggleClass = ['mobile-menu']
  if (collapseMenu) {
    toggleClass = [...toggleClass, 'on']
  }

  const navToggleHandler = () => {
    dispatch({ type: actionType.COLLAPSE_MENU })
  }

  // let moreClass = ['mob-toggler'];;
  // if (layout === 'horizontal') {
  //     moreClass = [...moreClass, 'd-none'];
  // }
  const collapseClass = ['collapse navbar-collapse']
  // if (moreToggle) {
  //     //moreClass = [...moreClass, 'on'];
  //     collapseClass = [...collapseClass, 'd-block']
  // }

  let navBar = (
    <>
      <div className="m-header">
        <Link
          to="#"
          className={toggleClass.join(' ')}
          id="mobile-collapse"
          onClick={navToggleHandler}
        >
          <span />
        </Link>
        <Link to="#" className="b-brand">
          <div className="b-bg" />
          <span className="b-title">{getLocalStorage('appname')}</span>
        </Link>
      </div>
      <div className={collapseClass.join(' ')}>
        {/* <NavLeft/> */}
        <NavRight
          entity={entity}
          scope={scope}
          entity_scope_name={entity_scope_name}
          username={username}
          profile={profile}
          logo={logo}
          admin={admin}
          client_access={client_access}
        />
      </div>
    </>
  )
  if (layout === 'horizontal' && subLayout === 'horizontal-2') {
    navBar = <div className="container">{navBar}</div>
  }

  return <header className={headerClass.join(' ')}>{navBar}</header>
}

export default NavBar

